<template>
  <div class="relative w-full k-video__container">
    <div
      v-if="isThumbnailActive"
      @click="showVideo"
      @keypress.space.enter="showVideo"
      tabIndex="0"
      role="button"
      aria-label="Play Video"
      class="k-video bg-black-high-emphasis absolute inset-0 overflow-hidden"
    >
      <img :src="thumbnail" role="presentation" alt="Know Before You Go Video Thumbnail" style="cursor: pointer" />
    </div>
    <div class="absolute inset-0" v-else>
      <iframe
        :tabindex="isThumbnailActive ? '-1' : '0'"
        class="w-full h-full"
        title="Know Before You Go"
        frameborder="0"
        height="auto"
        scrolling="auto"
        marginheight="0"
        marginwidth="0"
        autoplay="0"
        :src="url"
        allowfullscreen
        msallowfullscreen
        allow="fullscreen"
        :aria-describedby="transcript"
      ></iframe>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'

export default defineComponent({
  name: 'KVideo',
  props: {
    transcript: {
      type: String,
      required: true
    },
    url: {
      type: String,
      default: 'https://www.youtube.com/embed/jO9-oY_Wp7k'
    },
    thumbnail: {
      type: String
    },
    alt: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const isPlaying = ref(false)
    const isThumbnailActive = computed(() => !isPlaying.value && props.thumbnail)
    const showVideo = () => {
      isPlaying.value = true
    }
    return { isPlaying, isThumbnailActive, showVideo }
  }
})
</script>

<style scoped>
.k-video {
  &__container {
    padding-top: 56.25%;
  }
}
</style>
